// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___1eBgz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Editor/Editor.scss
// module id = 985
// module chunks = 0